import {DatePickerProps as MuiDatePickerProps} from '@mui/x-date-pickers/DatePicker';
import {VersionVariants} from '@jobseeker/lotus/enums';
import V1 from './V1';
import {Dayjs} from 'dayjs';
import {BaseSyntheticEvent} from 'react';

type MuiProps = Pick<
  MuiDatePickerProps<Dayjs, false>,
  | 'label'
  | 'defaultValue'
  | 'views'
  | 'name'
  | 'sx'
  | 'autoFocus'
  | 'inputRef'
  | 'openTo'
  | 'format'
  | 'disabled'
  | 'minDate'
  | 'maxDate'
  | 'onViewChange'
  | 'slotProps'
  | 'slots'
>;

export interface DatePickerProps extends MuiProps {
  variant: string | VersionVariants;
  value?: string;
  onChange?: (e: BaseSyntheticEvent) => void;
  setOpenDatePicker?: any;
}

let componentMap: {[key: string]: any} = {};

componentMap[VersionVariants.VERSION_ONE] = V1;

const Component = (props: DatePickerProps) => {
  let Component;
  if (Object.keys(componentMap).includes(props.variant)) {
    Component = componentMap[props.variant];
  } else {
    Component = componentMap[VersionVariants.VERSION_ONE];
  }
  return <Component {...props} />;
};

export default Component;
